import React from "react";
import { startCase } from "lodash";
import linkIcon from "assets/link.svg";

const BankAccountItem = ({ account }) => {
  const { mask, institutionName, name } = account;
  // currently all accounts here will show up as no matches

  return (
    <div
      style={{ height: 60, minWidth: 196 }}
      className="flex flex-1 flex-col justify-center px-4 border border-neutral-300 rounded">
      <div className="flex items-center">
        <img src={linkIcon} alt={institutionName} />
        <p className="ml-2 font-bold">{institutionName}</p>
      </div>
      <p>
        <p className="text-sm font-normal truncate">{`${startCase(name)} (${(
          mask || ""
        ).slice(-4)})`}</p>
      </p>
    </div>
  );
};

export default BankAccountItem;